import replace from 'lodash/replace';

import appRoutes from './routes';

const extractVariables = (routePath: string): string[] => {
  const segments = routePath.split('/');

  return segments
    .filter((segment) => segment.charAt(0) === ':' || segment.charAt(segment.length - 1) === '?')
    .map((segment) => replace(segment, /[:?]/g, ''));
};

const mapParamsToVariables = (variables: string[], params: Record<string, string | number>): Record<string, string> => {
  let map = {};

  variables.forEach((variable) => {
    map = {
      ...map,
      [variable]: params[variable] || undefined,
    };
  });

  return map;
};

const replaceRouteVariables = (
  routePath: string,
  variables: string[],
  keyValue: Record<string, string | number>,
): string => {
  let result = routePath;

  variables.forEach((variable) => {
    const param = keyValue[variable];

    result = replace(result, `:${variable}`, param ? String(param) : '');
    result = replace(result, /[?]/g, '');
    result = result.replace(/\/$/, '');
  });

  return result;
};

export const getRoute = (
  key: keyof typeof appRoutes,
  params?: Record<string, string | number>,
  hasOptional?: boolean,
  routes: { [key: string]: string } = appRoutes,
): string => {
  const routePath = routes[key];

  if (!routePath) {
    console.error('[Status 404] Route does not exists with key:', key);
    return routes['404'];
  }

  if (!params && !hasOptional) {
    return routePath;
  }

  const variables = extractVariables(routePath);
  const keyValue = params ? mapParamsToVariables(variables, params) : {};

  return replaceRouteVariables(routePath, variables, keyValue);
};
